import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-the-template-j" }
const _hoisted_2 = { class: "p-the-template-j__inner" }
const _hoisted_3 = { class: "p-the-template-j__header" }
const _hoisted_4 = { "data-translate-skip": "" }
const _hoisted_5 = { class: "p-the-template-j__body" }
const _hoisted_6 = { class: "p-the-template-j__body__header" }
const _hoisted_7 = { class: "p-search-area" }
const _hoisted_8 = {
  key: 0,
  class: "p-the-template-j__new-add"
}
const _hoisted_9 = { "data-translate-skip": "" }
const _hoisted_10 = { class: "p-the-template-j__right-col" }
const _hoisted_11 = {
  key: 0,
  class: "p-the-template-j__shown-search-form-button"
}
const _hoisted_12 = {
  key: 1,
  class: "p-the-template-j__sorted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_FormSearch = _resolveComponent("FormSearch")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_Portal = _resolveComponent("Portal")!
  const _component_ButtonRefineBase = _resolveComponent("ButtonRefineBase")!
  const _component_ButtonRefine = _resolveComponent("ButtonRefine")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheBreadcrumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          (_ctx.heading)
            ? (_openBlock(), _createBlock(_component_CommonHeading, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.heading), 1),
                  _cache[4] || (_cache[4] = _createTextVNode("メッセージ", -1))
                ]),
                _: 1,
                __: [4]
              }))
            : _createCommentVNode("", true)
        ], true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.indicateSearchForm)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref: "searchFormElement",
                  class: _normalizeClass(["p-the-template-j__search", _ctx.executeSearchFormDomAnimation ? _ctx.searchFormClassName : '']),
                  style: _normalizeStyle(_ctx.executeSearchFormDomAnimation ? _ctx.serchFormStyle : {})
                }, [
                  _createVNode(_component_FormSearch, {
                    search: _ctx.search,
                    "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    placeholder: _ctx.searchPlaceholder,
                    onDoSearch: _ctx.doSearch
                  }, null, 8, ["search", "placeholder", "onDoSearch"])
                ], 6))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "filter", {}, undefined, true)
          ]),
          (_ctx.indicateNewAddButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_Portal, { to: "j-buttons" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonMain, {
                      class: "p-the-template-j__give-button",
                      tag: "a",
                      kind: "main",
                      href: _ctx.url
                    }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createTextVNode(" 新しく", -1)),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.thanksPointName), 1),
                        _cache[6] || (_cache[6] = _createTextVNode("を贈る ", -1))
                      ]),
                      _: 1,
                      __: [5,6]
                    }, 8, ["href"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.indicateSearchButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "p-the-template-j__shown-search-form-button__button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchSearchFormState && _ctx.switchSearchFormState(...args)))
                  }, [
                    _createVNode(_component_ButtonRefineBase, null, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("ユーザー検索", -1)
                      ])),
                      _: 1,
                      __: [7]
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.indicateSortedButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_ButtonRefine, {
                    refine: _ctx.sorted.target,
                    "onUpdate:refine": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sorted.target) = $event)),
                    heading: _ctx.filterHeading,
                    icon: "sorted",
                    "refine-item-list": _ctx.sorted.itemList,
                    shown: _ctx.sorted.shownState,
                    width: _ctx.widthRefineButton,
                    onDoSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doSort($event))),
                    onSwitchRefineState: _ctx.switchSortedState
                  }, null, 8, ["refine", "heading", "refine-item-list", "shown", "width", "onSwitchRefineState"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(_component_ValidationErrorText, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.errorMessage]
          ])
        ]),
        _createElementVNode("div", {
          ref: "contentElement",
          class: "p-the-template-j__body__content",
          style: _normalizeStyle(_ctx.contentElementStyle)
        }, [
          _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
        ], 4)
      ])
    ])
  ]))
}